<template>
  <section class="hero is-small">
    <div class="hero-head">
      <div class="imgel">
        
        <a href="/home"><img
          class="logo"
          src="./assets/Logo HelpHarma.png"
          alt="Helpharma"
        /></a>
      </div>
  
          <b-navbar class="menu" v-if="isAuthenticated" >
            <template #end>
          <b-navbar-item  href="/home" class="navbar-item separacion"  v-bind:style= "[ruta.indexOf('/home') !== -1 || ruta.indexOf('/login') !== -1? {'background':'#0b4ea2 ','color':'#fff' }:{'background':'transparent'}]" >
                Inicio
            </b-navbar-item>
            <b-navbar-item href="/order" class="navbar-item  separacion" v-bind:style= "[ruta.indexOf('/order') !== -1  ? {'background':'#0b4ea2','color':'#fff'} :{'background':'transparent'}]">
                Mis domicilios
            </b-navbar-item>
           <!-- <b-navbar-item href="/list-request-appointment" class="navbar-item separacion" v-bind:style= "[ruta.indexOf('/list-request-appointment') !== -1 ? {'background':'#0b4ea2','color':'#fff'} :{'background':'transparent'}]">
                Mis citas
            </b-navbar-item>-->
            <b-navbar-item href="/my-profile" class="navbar-item separacion" v-bind:style= "[ruta.indexOf('/my-profile')!== -1 ? {'background':'#0b4ea2','color':'#fff'} :{'background':'transparent'}]">
                Mi perfil
            </b-navbar-item>
            <b-navbar-item @click="goOut" class="navbar-item  separacion">
            
            <b-icon
                icon="logout"
               >
            </b-icon>
         Salir
            </b-navbar-item>
              </template >
          </b-navbar>
    </div>

    <div class="hero-body">
      <offline @detected-condition="handleConnectivityChange" />
      <router-view />
    </div>
  </section>
</template>

<script>
import offline from "v-offline";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "app",
  components: {
    offline,
  },
  data() {
    return {
      b:"",
      ruta:"",
      firstTime: true,
      langs: [
        { id: 1, code: "en", icon: "us", name: "English" },
        { id: 2, code: "es", icon: "co", name: "Español" },
      ],
      lang: { id: 2, code: "es", icon: "co", name: "Español" },
      isPublic: true,
      labelButton: "",
      showButtonReturn: false,
    };
  },
    created() {
   this.ruta= window.location.href;
    console.log("vvvvv",this.ruta)

    },
  computed: {
      
    ...mapGetters("auth", {
      isAuthenticated: "isAuthenticated",
      
    }),
    
  },
  watch: {
    lang() {

      this.$i18n.locale = this.lang.code;
    },
  },
  methods: {
    goMyOrders(b) {
       if(this.b==0 || this.b==1|| this.b==3|| this.b==2){
         this.b=1
      }
 
       this.$router.push( {path:'/order', params: {b: 1}});
    },
    goHome(b) {
      if(this.b==0 || this.b==1|| this.b==3|| this.b==2){
         this.b=0
      }
      
      this.$router.push( {path:'/home', params: {b: 0}});
     
    },
    goMyData(b) {
      if(this.b==0 || this.b==1|| this.b==3|| this.b==2){
        this.b=3
      }
          this.$router.push( {path:'/my-profile', params: {b: 3}});
    },
    goMyList(b) {
      if(this.b==0 || this.b==1|| this.b==3|| this.b==2){
       this.b=2
      }
     this.$router.push( {path:'/list-request-appointment', params: {b: 2}});
    },
    handleConnectivityChange(status) {
      
      let message = this.$t("app.no-internet-connection");
      let type = "is-danger";
      if (status) {
        message = this.$t("app.connected");
        type = "is-success";
      }

      if (!this.firstTime) {
        this.$buefy.toast.open({ message, type });
      }

      this.firstTime = false;

    },

    ...mapActions("auth", ["logout"]),
    goOut() {
      
      this.logout().then(() => {
        this.$router.push("/login");
        
      });
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
// * {
//   font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L", "Helvetica Neue",
//     Helvetica, Arial, sans-serif;
// }
.field.is-floating-in-label > :not(.datepicker):not(.timepicker):not(.taginput) .input, .field.is-floating-in-label > :not(.datepicker):not(.timepicker):not(.taginput) .taginput .taginput-container.is-focusable, .taginput .field.is-floating-in-label > :not(.datepicker):not(.timepicker):not(.taginput) .taginput-container.is-focusable, .field.is-floating-in-label > :not(.datepicker):not(.timepicker):not(.taginput) .textarea, .field.is-floating-in-label > :not(.datepicker):not(.timepicker):not(.taginput) select {
    padding-top: calc(3.25em / 2 - (1.5rem * 3 / 4) / 2);
    padding-bottom: 1px;
    height: 3.25em;
    border: 1px solid grey;
}
.separacion{
  border-radius: 30px;
    color: #4a4a4a;
    display: block;
    padding: 0.5em 0.75em;
      font-size:20px;

}

.color-buton {
  background: #ec1119 !important;
}
::placeholder {
  opacity:1 !important;
}
.input {
  background: transparent;
  border: none;
  
}


.menu{
  margin-top:3% !important;
right:8%;

}
li {
  float: right;
  
}

a {
  display: block;
  padding: 8px;
  background-color: transparent;
  
}
.logo{
  cursor: pointer;
  z-index:4;
}
a.navbar-item:focus,
a.navbar-item:focus-within,
a.navbar-item:hover,
a.navbar-item.is-active,
.navbar-link:focus,
.navbar-link:focus-within,
.navbar-link:hover,
.navbar-link.is-active {
  color: #fff !important;
  background: #0b4ea2 !important;
  background: rgba(11, 78, 162, 1);
  border-radius: 30px;
  -moz-border-radius: 30px;
  -webkit-border-radius: 30px;
}

.imgel {
  left: 7%;
  position: absolute;
  z-index: 7 !important;
  width: 12%;
  top: 3%;
}
.coloIcon {
  color: #000;
  background-repeat: no-repeat;
}
.navbar-item,
.navbar-link {
  height: 90%;
}
.cursorPoint {
  cursor: pointer;
  color: #ec1119 !important;
}
.img-logo {
  width: 50%;
}
#app {
  // margin: 0 60px;
}
.hero-body {
  // padding: 0;
}
.position {
  // padding-top: 3%;
}
.navbar {
  z-index:1;
  margin-top: 2%;
}
.navbar-item img {
  max-height: 7.75rem;
}
@media (max-width: 993px) {
.background_welcome[data-v-63a071a5] {
    margin-top: 2% !important;
}
}
@media (max-width: 769px) {
  .navbar-item .icon:only-child, .navbar-link .icon:only-child {
    margin-left: -0.25rem !important;
}
.imgel {
    width: 30%;
    z-index: 0 !important;
}
    .background_welcome{
    text-align:center;
      margin-top: 18% !important;
  }
  .menu {
    position: absolute;
    right: 3%;
}
.background_welcome[data-v-63a071a5] {
    margin-top: 19% !important;
}
 a:not([href]) {
        position: unset !important;
    
    right: 0% !important;
}
 .imgel {
    margin-left: 27%;
}
.navbar-burger{
  position:absolute;
  right:1%;
}
.imgel{
  width:30%;
}
}
.hero-body{
  z-index:0;
}
.imgel{
  z-index:1;
}
@media (max-width: 541px) {
 
 .imgel {
    margin-left: 23%;
}
.navbar-burger{
  position:absolute;
  right:1%;
}
.imgel{
  width:40%;
}
}
.hero-body{
  z-index:0;
}
.imgel{
  z-index:1;
}

@media (max-width: 1023px) {
.navbar-menu.is-active {
        position: fixed;
    top: 5%;
    height: 256px;
    right: 16%;
}

a:not([href]) {
        position: absolute;
    
    right: 2%;
}
.hero {
  margin-bottom:10%;
}
.navbar-item .icon:only-child, .navbar-link .icon:only-child {
    margin-left: -7.25rem;
    /* margin-right: -0.25rem; */
}
}
</style>
